<app-header></app-header>

<ion-content scrollbar class="report-task__container">
  <app-list-header
    (toggleFilter)="onToggleFilter()"
    [absoluteFilterButton]="true"
    [hideSeparator]="true"
  >
    <ng-container top>
      <div class="report-task__filter-inner-container">
        <app-select-dropdown
          *ngIf="!p.renderMobile"
          class="report-task__dropdown"
          [data]="dictionaryServ.reportTaskStatusValues"
          displayKey="key"
          (changeValueEvent)="onFilterStatus($event)"
          placeholder="REPORT.STATUS"
          [value]="reportServ.reportFilter.status"
        >
        </app-select-dropdown>
        <app-select-dropdown
          *ngIf="!p.renderMobile"
          class="report-task__dropdown"
          [data]="dictionaryServ.reportPriorityValues"
          displayKey="key"
          (changeValueEvent)="onFilterPriority($event)"
          placeholder="REPORT.PRIORITY"
          [value]="reportServ.reportFilter.priority"
        ></app-select-dropdown>
        <app-search-bar
          #searchBar
          [permissionEdit]="false"
          addLink=""
          buttonAddLabel=""
          (searchEvent)="onChangeSearch($event)"
          class="w-100"
        >
        </app-search-bar>
      </div>
    </ng-container>
  </app-list-header>

  <app-pagination-client-side
    [ngClass]="{'height-0': showLoader}"
    [componentRef]="componentRef"
    [columns]="columnsDefinition"
    [options]="options"
    (rowsLoaderReady)="rowsLoaderServiceReady($event)"
    (refreshRequest)="refreshView()"
  >
  </app-pagination-client-side>

  <div class="spin" *ngIf="showLoader">
    <app-loading-sti></app-loading-sti>
  </div>
</ion-content>
